import { useI18n } from 'vue-i18n';
import {
  StatisticsKind,
  type SoilTemperatureStatisticsParcel,
  type StatisticsOverviewParcel,
  type StatisticsWizardData
} from '..';
import dateFormat from 'date-fns/format';
import type { Ref } from 'vue';

export const useOverviewStep = (statisticsData: Ref<StatisticsWizardData>) => {
  const { t } = useI18n();

  const getOwnMetadata = (parcelId: string): StatisticsOverviewParcel[] => {
    if (!statisticsData.value.metadata.parcels.length) {
      return [];
    }

    const ownMetadata = statisticsData.value.metadata.parcels.filter((p) => p.parcelId === parcelId);

    if (statisticsData.value.kind === StatisticsKind.SOIL_TEMPERATURE) {
      const soilMetadata = ownMetadata as SoilTemperatureStatisticsParcel[];
      return soilMetadata.flatMap((item) => {
        const result: StatisticsOverviewParcel[] = [];
        result.push({
          statisticsSource: item.statisticsSource,
          label: `${t('statistics.wizard.label.fromDate')} : ${dateFormat(new Date(item.dateFrom), 'yyyy.MM.dd')}`
        });
        result.push({
          statisticsSource: item.statisticsSource,
          label: `${t('statistics.wizard.label.toDate')} : ${dateFormat(new Date(item.dateTo), 'yyyy.MM.dd')}`
        });
        return result;
      });
    }

    return ownMetadata as StatisticsOverviewParcel[];
  };

  return {
    getOwnMetadata
  };
};
